import { useState, Fragment } from "react";

import { Container, Grid, Col } from "../components/Layout";
import { Carousel, Rating } from "../components";
import { mq, bp } from "../components/responsive";

import { Heading, Paragraph } from "../components/UI/Typoraphy";
import { Flex } from "../components/shared";

/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { useMediaQuery } from "../hooks";

import CartShape from "../assets/cart-shape.svg";
import Cart from "../assets/cart.svg";

const product = {
  _id: "1",
  title: "Trang An",
  price: 120.0,
  location: "Ninh Binh",
  image: "/images/TrangAn.png",
  wished: false,
  rating: 3,
  duration: 4,
  public_date: "11/2/2020",
  tags: ["Food and Beverage", "Artisan Villages"],
  reviews: ["Dasdas", "asdad"],
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
};

function Detail({ data = product }) {
  const mediaQuery = useMediaQuery();
  const [wished, setWished] = useState(data.wished);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handleWish = () => setWished((wished) => !wished);

  return (
    <Container
      style={{
        height: "calc(100vh - 10rem)",

        [mq.xl]: {
          padding: "0 30rem",
        },
      }}
    >
      <Grid gutter={{ xs: 24, md: 64 }} style={{ height: "100%" }}>
        <Col span={{ xs: 4, md: 6 }}>
          <Carousel
            render={(item) => (
              <img
                src={item.src}
                alt={item.alt}
                css={{ height: "100%", width: "auto" }}
              />
            )}
            indicatorType={mediaQuery.up(bp.md) ? "photos" : "dots"}
            indicatorStyle={{
              position: "absolute",
              transform: "translateX(-50%)",
              bottom: "2rem",
              left: "50%",
              flexDirection: "row",
              margin: 0,

              "& > div": {
                margin: "0 0.5rem",
              },
            }}
            items={[
              {
                src: "/images/Sky.jpg",
                alt: "Sky",
              },

              {
                src: "/images/Rosie.jpg",
                alt: "Rosie",
              },
              {
                src: "/images/Phobe.jpg",
                alt: "Phobe",
              },
              {
                src: "/images/Sky.jpg",
                alt: "Sky",
              },

              {
                src: "/images/Rosie.jpg",
                alt: "Rosie",
              },
              {
                src: "/images/Phobe.jpg",
                alt: "Phobe",
              },
            ]}
            height={mediaQuery.up(bp.md) ? " 45rem" : "30rem"}
          />
        </Col>
        <Col
          span={{ xs: 4, md: 6 }}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 10rem - 30rem)",
          }}
        >
          <Flex
            css={{
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <Heading level={2} style={{ marginBottom: 0 }}>
              {data.title}
            </Heading>
            <span
              css={{
                cursor: "pointer",
                zIndex: 1,
              }}
              onClick={handleWish}
            >
              {wished ? (
                <i
                  className="fas fa-heart"
                  style={{ fontSize: "3rem", color: "#ff794b" }}
                ></i>
              ) : (
                <i
                  className="far fa-heart"
                  style={{ fontSize: "3rem", color: "#ff794b" }}
                ></i>
              )}
            </span>
          </Flex>
          <Flex
            style={{
              color: "#7D7D7D",
              marginBottom: "3rem",

              alignItems: "center",
            }}
          >
            <Paragraph> {data.location}</Paragraph>

            {data.duration && (
              <Fragment>
                <div
                  css={{
                    width: "1rem",
                    height: "1rem",
                    borderRadius: "50%",
                    backgroundColor: "#C4C4C4",
                    margin: "0 6rem",
                  }}
                ></div>
                <Paragraph>
                  {data.duration} {data.duration > 1 ? "hours" : "hour"}
                </Paragraph>
              </Fragment>
            )}
          </Flex>
          <Paragraph
            style={{
              color: "#939DA9",
              marginBottom: "2rem",
              [mq.md]: {
                marginBottom: "10rem",
              },
            }}
          >
            {data.description}
          </Paragraph>
          <Flex
            css={{
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "2rem",

              [mq.md]: {
                marginBottom: "4rem",
              },
            }}
          >
            <Flex style={{ alignItems: "center" }}>
              <Rating rate={data.rating} />
              &nbsp;<Paragraph>{data.rating.toFixed(1)}</Paragraph>
            </Flex>
            {data.reviews.length && (
              <Paragraph style={{ color: "#7D7D7D" }} type="quote">
                {data.reviews.length}
                {data.reviews.length > 1 ? " reviews" : " review"}
              </Paragraph>
            )}
          </Flex>
          <Flex
            css={{
              flex: 2,
              justifyContent: "flex-end",
              flexDirection: "column",

              [mq.md]: {
                flex: "unset",
              },
            }}
          >
            <Flex
              css={{
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "6rem",
              }}
            >
              <Heading
                level={3}
                style={{
                  position: "relative",

                  "&:before": {
                    content: `""`,
                    height: "8rem",
                    width: "8rem",
                    position: "absolute",
                    backgroundColor: "#DEF4E5",
                    left: "-2rem",
                    borderRadius: "50%",
                    transform: "translateY(-50%)",
                    top: "50%",
                    zIndex: -1,
                  },
                }}
              >
                {formatter.format(data.price)}
              </Heading>
              <Flex
                css={{
                  position: "relative",
                }}
              >
                <img
                  src={Cart}
                  alt="add-to-cart"
                  css={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
                <img src={CartShape} alt="add-to-cart-bg" />
              </Flex>
            </Flex>
          </Flex>
        </Col>
      </Grid>
    </Container>
  );
}

export default Detail;
